import { __makeTemplateObject } from '../../_virtual/_tslib.js';
import React, { useState } from 'react';
import styled from 'styled-components';
import LoadingSpinnerSvg from '../../common/LoadingSpinnerSvg/LoadingSpinnerSvg.js';

var getColor = function getColor(theme) {
  return {
    gray: theme.colorTokens.text.secondary,
    black: theme.colorTokens.text.primary,
    white: theme.colorTokens.accent.on
  };
};

var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n  svg {\n    path {\n      stroke: ", ";\n    }\n  }\n"], ["\n  width: ", ";\n  height: ", ";\n  svg {\n    path {\n      stroke: ", ";\n    }\n  }\n"])), function (_a) {
  var size = _a.size;

  switch (size) {
    case 'large':
      return '4rem';

    case 'medium':
      return '3.2rem';

    case 'small':
      return '2.4rem';

    default:
      return '1.8rem';
  }
}, function (_a) {
  var size = _a.size;

  switch (size) {
    case 'large':
      return '4rem';

    case 'medium':
      return '3.2rem';

    case 'small':
      return '2.4rem';

    default:
      return '1.8rem';
  }
}, function (_a) {
  var theme = _a.theme,
      color = _a.color;
  return getColor(theme)[color];
});

function LoadingSpinner(_a) {
  var size = _a.size,
      color = _a.color;

  var _b = useState(null),
      container = _b[0],
      setContainer = _b[1];

  return React.createElement(Wrapper, {
    ref: setContainer,
    color: color,
    size: size
  }, React.createElement(LoadingSpinnerSvg, {
    container: container
  }));
}

var templateObject_1;
export { LoadingSpinner as default };